export const CARD_TOOLTIPS: Record<string, string> = {
  "Total Calls Offered":
    "Total number of calls during the period, including incoming calls, outgoing calls, internal calls.",
  "Poor Call Rate": "Percent of calls classified as Poor.",
  "Call Set Up Failed":
    "Percentage of calls where the media path couldn't be established between endpoints at call start.",
  "Call Drop Failed":
    "The percentage of successfully established streams where the media path did not terminate unexpectedly.",
  "Avg Packet Loss":
    "Percentage of data packets that never arrive, causing audio gaps or distortion. Lower is better.",
  "Avg MOS Score":
    "Average Network Mean Opinion Score degradation showing how network loss and jitter impact audio quality. Higher is better.",
  "Avg Jitter":
    "Average variation in packet arrival times, which can cause choppy audio. Lower is better.",
  "Avg Round Trip":
    "Time (ms) for a packet to travel to the receiver and back, measuring network latency. Lower is better.",
};